module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/miyako_access_01-1da73d63b2b6ec69d942620770d52fe6.jpg";